import makeActionCreator from './makeActionCreator'
import * as actionTypes from './actionTypes'

export const fetchIdea = makeActionCreator(actionTypes.FETCH_IDEA, 'id')
// export const fetchIdeaLoading = makeActionCreator(actionTypes.FETCH_IDEA_LOADING);
export const fetchIdeaSuccess = makeActionCreator(
  actionTypes.FETCH_IDEA_SUCCESS,
  'prioritize'
)
export const fetchIdeaError = makeActionCreator(
  actionTypes.FETCH_IDEA_ERROR,
  'error'
)
// export const fetchIdeaDone = makeActionCreator(actionTypes.FETCH_IDEA_DONE);

export const addNewIdea = makeActionCreator(actionTypes.ADD_NEW_IDEA, 'id')
// export const addNewIdeaLoading = makeActionCreator(actionTypes.ADD_NEW_IDEA_LOADING);
export const addNewIdeaSuccess = makeActionCreator(
  actionTypes.ADD_NEW_IDEA_SUCCESS,
  'prioritize'
)
export const addNewIdeaError = makeActionCreator(
  actionTypes.ADD_NEW_IDEA_ERROR,
  'error'
)
// export const addNewIdeaDone = makeActionCreator(actionTypes.ADD_NEW_IDEA_DONE);

export const removeIdea = makeActionCreator(actionTypes.REMOVE_IDEA, 'id')
// export const removeIdeaLoading = makeActionCreator(actionTypes.REMOVE_IDEA_LOADING);
export const removeIdeaSuccess = makeActionCreator(
  actionTypes.REMOVE_IDEA_SUCCESS,
  'prioritize'
)
export const removeIdeaError = makeActionCreator(
  actionTypes.REMOVE_IDEA_ERROR,
  'error'
)
// export const removeIdeaDone = makeActionCreator(actionTypes.REMOVE_IDEA_DONE);

export const addNewFactor = makeActionCreator(
  actionTypes.ADD_NEW_FACTOR,
  'preset'
)
// export const addNewFactorLoading = makeActionCreator(actionTypes.ADD_NEW_FACTOR_LOADING);
// export const addNewFactorSuccess = makeActionCreator(actionTypes.ADD_NEW_FACTOR_SUCCESS, 'prioritize');
// export const addNewFactorError = makeActionCreator(actionTypes.ADD_NEW_FACTOR_ERROR, 'error');
// export const addNewFactorDone = makeActionCreator(actionTypes.ADD_NEW_FACTOR_DONE);

export const getCurrentCollection = makeActionCreator(
  actionTypes.GET_CURRENT_COLLECTION,
  'payload'
)
export const deleteCurrentCollection = makeActionCreator(
  actionTypes.DELETE_CURRENT_COLLECTION,
  'payload'
)
export const getPresetsDropdown = makeActionCreator(
  actionTypes.GET_PRESETS,
  'payload'
)
export const getResultsForCollection = makeActionCreator(
  actionTypes.GET_RESULTS_FOR_COLLECTION,
  'payload'
)
export const setCurrentFactors = makeActionCreator(
  actionTypes.SET_CURRENT_FACTORS,
  'payload'
)
export const setTemplateFactors = makeActionCreator(
  actionTypes.SET_TEMPLATE_FACTORS,
  'payload'
)

// FACTORS
export const createQuestions = makeActionCreator(
  actionTypes.CREATE_QUESTIONS,
  'payload'
)
export const createQuestionsStart = makeActionCreator(
  actionTypes.CREATE_QUESTIONS_START,
  'payload'
)
export const createQuestionsSuccess = makeActionCreator(
  actionTypes.CREATE_QUESTIONS_SUCCESS,
  'payload'
)
export const createQuestionsError = makeActionCreator(
  actionTypes.CREATE_QUESTIONS_ERROR,
  'payload'
)
export const createQuestionsDone = makeActionCreator(
  actionTypes.CREATE_QUESTIONS_DONE,
  'payload'
)

export const updateQuestion = makeActionCreator(
  actionTypes.UPDATE_QUESTION,
  'payload'
)
export const updateQuestionStart = makeActionCreator(
  actionTypes.UPDATE_QUESTION_START,
  'payload'
)
export const updateQuestionSuccess = makeActionCreator(
  actionTypes.UPDATE_QUESTION_SUCCESS,
  'payload'
)
export const updateQuestionError = makeActionCreator(
  actionTypes.UPDATE_QUESTION_ERROR,
  'payload'
)
export const updateQuestionDone = makeActionCreator(
  actionTypes.UPDATE_QUESTION_DONE,
  'payload'
)

export const deleteQuestion = makeActionCreator(
  actionTypes.DELETE_QUESTION,
  'payload'
)
export const deleteQuestionStart = makeActionCreator(
  actionTypes.DELETE_QUESTION_START,
  'payload'
)
export const deleteQuestionSuccess = makeActionCreator(
  actionTypes.DELETE_QUESTION_SUCCESS,
  'payload'
)
export const deleteQuestionError = makeActionCreator(
  actionTypes.DELETE_QUESTION_ERROR,
  'payload'
)
export const deleteQuestionDone = makeActionCreator(
  actionTypes.DELETE_QUESTION_DONE,
  'payload'
)

export const deleteQuestions = makeActionCreator(
  actionTypes.DELETE_QUESTIONS,
  'payload'
)
export const deleteQuestionsStart = makeActionCreator(
  actionTypes.DELETE_QUESTIONS_START,
  'payload'
)
export const deleteQuestionsSuccess = makeActionCreator(
  actionTypes.DELETE_QUESTIONS_SUCCESS,
  'payload'
)
export const deleteQuestionsError = makeActionCreator(
  actionTypes.DELETE_QUESTIONS_ERROR,
  'payload'
)
export const deleteQuestionsDone = makeActionCreator(
  actionTypes.DELETE_QUESTIONS_DONE,
  'payload'
)

export const fetchCollection = makeActionCreator(
  actionTypes.FETCH_COLLECTION,
  'payload'
)
export const fetchCollectionStart = makeActionCreator(
  actionTypes.FETCH_COLLECTION_START,
  'payload'
)
export const fetchCollectionSuccess = makeActionCreator(
  actionTypes.FETCH_COLLECTION_SUCCESS,
  'payload'
)
export const fetchCollectionError = makeActionCreator(
  actionTypes.FETCH_COLLECTION_ERROR,
  'payload'
)
export const fetchCollectionDone = makeActionCreator(
  actionTypes.FETCH_COLLECTION_DONE,
  'payload'
)

export const createPresetQuestionsSuccess = makeActionCreator(
  actionTypes.CREATE_PRESET_QUESTIONS_SUCCESS,
  'payload'
)
export const createPresetQuestionsError = makeActionCreator(
  actionTypes.CREATE_PRESET_QUESTIONS_ERROR,
  'payload'
)
export const createPresetQuestionsDone = makeActionCreator(
  actionTypes.CREATE_PRESET_QUESTIONS_DONE,
  'payload'
)

export const getPresets = makeActionCreator(actionTypes.GET_PRESETS, 'payload')
export const getPresetsStart = makeActionCreator(
  actionTypes.GET_PRESETS_START,
  'payload'
)
export const getPresetsSuccess = makeActionCreator(
  actionTypes.GET_PRESETS_SUCCESS,
  'payload'
)
export const getPresetsError = makeActionCreator(
  actionTypes.GET_PRESETS_ERROR,
  'payload'
)
export const getPresetsDone = makeActionCreator(
  actionTypes.GET_PRESETS_DONE,
  'payload'
)

export const setCurrentPreset = makeActionCreator(
  actionTypes.SET_CURRENT_PRESET,
  'payload'
)

export const getQuestionsByCollectionId = makeActionCreator(
  actionTypes.GET_QUESTIONS_BY_COLLECTION_ID,
  'payload'
)
export const getQuestionsByCollectionIdStart = makeActionCreator(
  actionTypes.GET_QUESTIONS_BY_COLLECTION_ID_START,
  'payload'
)
export const getQuestionsByCollectionIdSuccess = makeActionCreator(
  actionTypes.GET_QUESTIONS_BY_COLLECTION_ID_SUCCESS,
  'payload'
)
export const getQuestionsByCollectionIdError = makeActionCreator(
  actionTypes.GET_QUESTIONS_BY_COLLECTION_ID_ERROR,
  'payload'
)
export const getQuestionsByCollectionIdDone = makeActionCreator(
  actionTypes.GET_QUESTIONS_BY_COLLECTION_ID_DONE,
  'payload'
)

export const getComments = makeActionCreator(
  actionTypes.GET_COMMENTS,
  'payload'
)
export const getCommentsStart = makeActionCreator(
  actionTypes.GET_COMMENTS_START,
  'payload'
)
export const getCommentsSuccess = makeActionCreator(
  actionTypes.GET_COMMENTS_SUCCESS,
  'payload'
)
export const getCommentsError = makeActionCreator(
  actionTypes.GET_COMMENTS_ERROR,
  'payload'
)
export const getCommentsDone = makeActionCreator(
  actionTypes.GET_COMMENTS_DONE,
  'payload'
)

export const postComment = makeActionCreator(
  actionTypes.POST_COMMENT,
  'payload'
)
export const postCommentStart = makeActionCreator(
  actionTypes.POST_COMMENT_START,
  'payload'
)
export const postCommentSuccess = makeActionCreator(
  actionTypes.POST_COMMENT_SUCCESS,
  'payload'
)
export const postCommentError = makeActionCreator(
  actionTypes.POST_COMMENT_ERROR,
  'payload'
)
export const postCommentDone = makeActionCreator(
  actionTypes.POST_COMMENT_DONE,
  'payload'
)
